import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { LocalService } from '../services/localService'
import { SharingService } from '../services/sharing.service'

@Injectable({
  providedIn: 'root'
})

export class RutaGuard implements CanActivate {
  constructor(private _router: Router, 
    private _localService: LocalService,
    private _sharingService: SharingService
  ) {     
  }
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    var rutas
    let permiso = false
    rutas = this._localService.getJsonValue("rutas")
    if (rutas == null) {
      rutas = []
      permiso = true
    }else{
      rutas = (JSON.parse(rutas))
      for (let r = 0; r < rutas.length; r++) {
        const acceso = rutas[r];
        if (acceso == state.url) {
          permiso = true
        }
      }
    }
    if (permiso == false) {
      this._router.navigate(["/inicio"])
    }

    return permiso
  }
}

